import { Navigate, Route, Routes } from "react-router-dom";
import AppShell from "../components/AppShell";
import { DESIGN_API, GLOBAL_SETTINGS, ON_BOARD, OVERVIEW, REVIEW_SPEC, ROOT } from "./paths";
import DesignApiPage from "../pages/DesignApiPage";
import GlobalSettingsPage from "../pages/GlobalSettingsPage";
import OnBoardPage from "../pages/OnBoardPage";
import OverviewPage from "../pages/OverviewPage";
import ReviewSpecPage from "../pages/ReviewSpecPage";

const AppRoutes = () => (
  <Routes>
    <Route path={ROOT} element={<AppShell />}>
      <Route index element={<Navigate to={OVERVIEW} replace />} />
      <Route path={OVERVIEW} element={<OverviewPage />} />
      <Route path={DESIGN_API} element={<DesignApiPage />} />
      <Route path={GLOBAL_SETTINGS} element={<GlobalSettingsPage />} />
      <Route path={ON_BOARD} element={<OnBoardPage />} />
      <Route path={REVIEW_SPEC} element={<ReviewSpecPage />} />
    </Route>
  </Routes>
);

export default AppRoutes;
